import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import DashboardNavigation from '../components/DashboardNavigation.tsx';

export default function DashboardList() {
  return (
    <Box sx={{ p: '0 1.5rem 2.5rem', width: '100%', height: '100vh', boxSizing: 'border-box' }}>
      <Typography sx={{
        fontFamily: "'Syne', sans-serif",
        fontSize: 20,
        fontWeight: 600,
        color: '#1D9E75',
        mb: 3,
      }}>
        Dashboard List
      </Typography>
      <DashboardNavigation />
    </Box>
  );
}
